import type { VideoCategory } from '../types'

export const courseVideos: VideoCategory[] = []
